/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const InternalForUserParser = /* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['restrictionsId', /* #__PURE__ */ parsers.maybeNull(codecString), 'restrictions_id'],
    ['userIpAddr', codecString, 'user_ip_addr'],
]);
export class InternalForUser extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return InternalForUserParser.decode(input).map(res => new InternalForUser(res));
    }
    static unsafeDecode(input) {
        return InternalForUser.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return InternalForUserParser.encode(data);
    }
    static schema() {
        return InternalForUserParser.schema();
    }
}
